export const LISTEN_TO_CURRENT_USER = "LISTEN_TO_CURRENT_USER";
export const LISTEN_TO_SELECTED_USER = "LISTEN_TO_SELECTED_USER";
export const LISTEN_TO_USER_PHOTOS = "LISTEN_TO_USER_PHOTOS";
